import { useEffect } from "react";
import { useForm } from "../../useForm";
import SetupSlideOverFormActions from "../SetupSlideOverFormActions";
import { useSlideOverSubmit } from "../useSlideOverSubmit";

import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import Input from "../../../controls/Input";

const initialFValues = {
  name: "",
  is_active: true,
};

export default function LocationZoneForm(props) {
  const { zone, setOpen, actionCall, isEdit } = props;

  const { values, setValues, handleInputChange } = useForm(
    initialFValues,
    false,
  );
  const { submitting, runSubmit } = useSlideOverSubmit();

  const handleSubmit = (e) => {
    e.preventDefault();
    runSubmit(async () => {
      await actionCall(values, zone);
    });
  };

  useEffect(() => {
    if (isEdit && zone) {
      setValues({
        name: zone.name ?? "",
        is_active: zone.is_active !== false,
      });
    }
  }, [isEdit, zone, setValues]);

  return (
    <div className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
        <div className="px-4 sm:px-6">
          <div className="flex items-start justify-between">
            <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
              {isEdit ? "Edit zone" : "Add zone"}
            </Dialog.Title>
            <button
              type="button"
              className="rounded-md bg-white text-gray-400 hover:text-gray-500"
              onClick={() => setOpen({ childComponent: null, open: false })}
            >
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
        </div>
        <form
          id="location-zone-form"
          onSubmit={handleSubmit}
          className="relative mt-6 flex-1 space-y-4 px-4 sm:px-6"
        >
          <Input
            label="Zone name"
            name="name"
            onChange={handleInputChange}
            value={values.name}
            labelOn={true}
            type="text"
            required
          />
          <label className="flex items-center gap-2 text-sm text-[#0F172A]">
            <input
              type="checkbox"
              name="is_active"
              checked={values.is_active}
              onChange={(e) =>
                setValues((current) => ({
                  ...current,
                  is_active: e.target.checked,
                }))
              }
              className="h-4 w-4 rounded border-[#CBD5E1] text-[#16A34A] focus:ring-[#16A34A]"
            />
            Active
          </label>
        </form>
      </div>
      <SetupSlideOverFormActions
        setOpen={setOpen}
        isEdit={isEdit}
        submitting={submitting}
        formId="location-zone-form"
        variant="modern"
      />
    </div>
  );
}
